import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

type NfcLandingPageHeroBubbleProps = {
  className?: string
}

export const NfcLandingPageHeroBubble: FC<NfcLandingPageHeroBubbleProps> = ({
  className,
}) => {
  return (
    <div
      className={clsx(
        'flex size-32 flex-col items-center justify-center gap-1 rounded-full bg-light-tertiary',
        className,
      )}
    >
      <span className="w-full text-center font-mono text-xs font-medium uppercase text-dark-primary-max">
        <FormattedMessage id="nfc.hero.bubble.text" />
      </span>
      <span className="mx-auto rounded-lg bg-light-primary-low px-2 py-1 font-mono text-xs font-medium uppercase">
        <FormattedMessage id="nfc.hero.bubble.discount" />
      </span>
    </div>
  )
}
